module.exports = __webpack_public_path__ + "static/media/the-race-to-improve-food-security.5973674f.jpg";